import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

import EditSubscription from '../../../modal/Subscription_Management/Manage_Subscriptions/EditSubscription';
import ViewSubscription from '../../../modal/Subscription_Management/Manage_Subscriptions/ViewSubscription';
import RenewalSubscription from '../../../modal/Subscription_Management/Manage_Subscriptions/RenewalSubscription';
import HoldSubscription from '../../../modal/Subscription_Management/Manage_Subscriptions/HoldSubscription';
import ComplaintsSubscription from '../../../modal/Subscription_Management/Manage_Subscriptions/ComplaintsSubscription';
import SubSpecialCase from '../../../modal/Subscription_Management/Manage_Subscriptions/SubSpecialCase';
import SubPayment from '../../../modal/Subscription_Management/Manage_Subscriptions/SubscriptionPayment';
import DropStatus from '../../../modal/Subscription_Management/Manage_Subscriptions/DropStatus';
import LoadingComponent from '../../../layouts/nav/loading';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const getStartOfWeek = (date) => {
  const day = date.getDay(), // get the current day of the week
    diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
  const startOfWeek = new Date(date.setDate(diff));
  startOfWeek.setHours(0, 0, 0, 0); // set to midnight
  return startOfWeek;
};

const getEndOfWeek = (date) => {
  const day = date.getDay(),
    diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
  const endOfWeek = new Date(date.setDate(diff));
  endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
  return endOfWeek;
};

const Subscription = () => {

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const user_id = parseInt(localStorage.getItem("user_id"), 10);

  // ------------------------------- role permission -------------------------------------------

  // default no permission structure
  const defaultPermissions = {
    view_dashboard: 0,
    branch_man: 0,


    // ------------------------------- subscription ------------------
    subs_man: 0,
    man_subs: 0,
    subscription_list: 0,
    subscription_view: 0,
    subscription_edit: 0,
    subscription_export: 0,
    subscription_hold: 0,
    subscription_complaints: 0,
    subscription_renewal: 0,
    subscription_payment: 0,
    subscription_drop: 0,
    subscription_special_case: 0,

    man_order: 0,
    order_list: 0,
    order_edit: 0,
    order_view: 0,
    order_new_subs: 0,
    order_drop_subs: 0,
    order_convert_subscriber: 0,

    man_drop: 0,
    drop_list: 0,
    drop_export: 0,

    // ----------------------------------- payment ------------------------
    pay_man: 0,
    man_payment: 0,
    payment_export: 0,
    payment_list: 0,

    man_refund: 0,
    refund_list: 0,
    refund_export: 0,
    refund_update: 0,
  };

  // Immediately load from localStorage if available
  const initialPermissions = (() => {
    const stored = localStorage.getItem('user_permissions');
    return stored ? JSON.parse(stored) : defaultPermissions;
  })();

  const [permissions, setPermissions] = useState(initialPermissions);

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
  const [datas, setData] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  // pagination
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [perPage, setPerPage] = useState(25);
  const [total_entries, setTotslEntries] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.toastMessage) {
      const type = location.state.toastType === 'success' ? toast.success : toast.error;
      type(location.state.toastMessage);
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [yeardisplay, setyeardisp] = useState(new Date());

  const fetchData = (filter = {}) => {
    setLoading(true);
    const params = {
      ...filter,
      page,
      per_page: perPage,
      search: searchTerm,
      branch_id: branch_id,
      user_id: user_id,
      month: yeardisplay.getMonth() + 1,
      year: yeardisplay.getFullYear(),
    };
    axios.get(`${baseURL}/subscription/monthly`, { params: params })
      .then(response => {
        setData(response.data.data);
        setHasFetched(true);
        setTotalPages(response.data.last_page);
        setTotslEntries(response.data.total);
        setLoading(false);
      })
      .catch(error => {
        console.log('There was an error fetching the data!', error);
        setHasFetched(true);
        setLoading(false);
      });
  };

  useEffect(() => {
    const filter = {
      lead: filter_subs_id || '',
      search: filtermob_no || '',
      package_id: pack || '',
      schedule_id: schedule || '',
      date_filter: date_fil_selt_value || '',
    };
    if (date_fil_selt_value === 'custom') {
      filter.start_date = custom_stdt_fil_value || '';
      filter.end_date = custom_eddt_fil_value || '';
    }
    fetchData(filter);
  }, [yeardisplay, page, perPage, searchTerm]);

  const tableScrollRef = useRef(null);
  const tableRef = useRef(null);
  const [tableWidth, setTableWidth] = useState(0);

  const [modalType, setModalType] = useState("");
  const [open, setOpen] = useState(false);

  const [selectedId, setSelecctedID] = useState("");
  const [selectedRow, setSelectedRow] = useState({});

  const EditSubscriptionModal = (selectedRow) => {
    setSelectedRow(selectedRow);
    setModalType("EditSubscription");
    setOpen(true);
  };
  const ViewSubscriptionModal = (selectedId) => {
    setSelecctedID(selectedId);
    setModalType("ViewSubscription");
    setOpen(true);
  };

  const HoldSubscriptionModal = (selectedRow) => {
    setSelectedRow(selectedRow);
    setModalType("HoldSubscription");
    setOpen(true);
  };

  const SubscriptionPaymentModel = (selectedRow) => {
    setSelectedRow(selectedRow);
    setModalType("SubscriptionPayment");
    setOpen(true);
  };
  const SubSpecialCaseModal = (selectedRow, selectedId) => {
    setSelecctedID(selectedId);
    setSelectedRow(selectedRow);
    setModalType("SubSpecialCase");
    setOpen(true);
  };
  const ConstDropStatus = (selectedRow) => {
    setSelectedRow(selectedRow);
    setModalType("DropStatus");
    setOpen(true);
  };

  const [month_fil_value, setMonthFilValue] = useState(new Date());
  const onClose = () => {
    setFilterOpen(false);
  };
  const [filterOpen, setFilterOpen] = useState(false);
  useEffect(() => {
    if (hasFetched) {
      if (tableRef.current) {
        setTableWidth(tableRef.current.offsetWidth);
      }
      const handleResize = () => {
        if (tableRef.current) setTableWidth(tableRef.current.offsetWidth);
      };
      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [hasFetched]);

  // ----------------------- styles  ------------------------------

  const thStyle = {
    border: "1px solid #dee2e6",
    textAlign: "center",
    verticalAlign: "middle",
    padding: "8px",
    background: "#fff",
    fontWeight: "bold",

  };
  const tdStyle = {
    minWidth: "100px",
    height: "100px",
    border: "1px solid #dee2e6",
    textAlign: "center",
    verticalAlign: "middle",
  };
  const tdStyleFirstTwo = {
    minWidth: "100px",
    height: "100px",
    border: "1px solid #dee2e6",
    textAlign: "center",
    verticalAlign: "middle",
    paddingLeft: "10px"
  };
  const stickyLeft1 = {
    position: "sticky",
    left: 0,
    zIndex: 5,
    background: "#f2f2f2",
    minWidth: "200px",
  };
  const stickyLeft2 = {
    position: "sticky",
    left: "200px",
    zIndex: 5,
    background: "#fafafa",
    minWidth: "200px",

  };
  const stickyLeft3 = {
    position: "sticky",
    left: "400px",
    zIndex: 5,
    background: "#e6e6e6",
    minWidth: "200px",
  };
  const blinkingStyle = {
    animation: "blink 3s infinite",
  };

  // -------------------------------------- Filter section ---------------------------------

  // package options
  const [packageOption, setPackOption] = useState([]);
  const [pack, setPack] = useState(null);
  useEffect(() => {
    const fetchLeadSource = async () => {
      try {
        const response = await axios.get(`${baseURL}/dropdown/package?branch_id=${branch_id}`);
        const formattedsource = response.data.data.map(item => ({
          value: item.sno,
          label: item.package_name,
        }));
        const allOption = { value: null, label: "All" };
        setPackOption([allOption, ...formattedsource]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchLeadSource();
  }, []);

  // schedule
  const [scheduleOption, setScheduleOption] = useState([]);
  const [schedule, setschedule] = useState(null);
  useEffect(() => {
    const fetchLeadSource = async () => {
      try {
        const response = await axios.get(`${baseURL}/dropdown/get_schedule`);
        const formattedsource = response.data.map(item => ({
          value: item.sno,
          label: item.itemschedule_name,
        }));
        const allOption = { value: null, label: "All" };
        setScheduleOption([allOption, ...formattedsource]);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchLeadSource();
  }, []);

  // subs option & on select
  const [filter_subs_id, setFilterSubsID] = useState(null);
  const [subsribersOpt, setSubscribersOpt] = useState([]);
  useEffect(() => {
    axios.get(`${baseURL}/leadsubscription/subscribers`, { params: { branch_id } })
      .then(response => {
        const formatted = response.data.data.map(item => ({
          value: item.lead,
          label: item.lead_name,
        }));
        const allOption = { value: null, label: "All" };
        setSubscribersOpt([allOption, ...formatted]);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  const [filtermob_no, setFilterMob] = useState('');
  const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
  const [today_fil_value, setTodayFilValue] = useState(new Date());
  const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
  const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
  const [month_fil_value_filter, setMonthFilValueFilter] = useState(new Date());
  const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
  const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

  const date_fil_options = [
    { value: "all", label: "All" },
    { value: "today", label: "Today" },
    { value: "this_week", label: "This week" },
    { value: "this_month", label: "This Month" },
    { value: "custom", label: "Custom Date" }
  ];


  const handleGoClick = () => {
    const filter = {
      lead: filter_subs_id || '',
      search: filtermob_no || '',
      package_id: pack || '',
      schedule_id: schedule || '',
      date_filter: date_fil_selt_value || '',
    };
    if (date_fil_selt_value === 'custom') {
      filter.start_date = custom_stdt_fil_value || '';
      filter.end_date = custom_eddt_fil_value || '';
    }
    setHasFetched(false);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    fetchData(filter);
    onClose();
  };


  const daysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const generateTableHead = (date) => {
    const d = date instanceof Date ? date : new Date(date);

    if (isNaN(d)) return [];

    const year = d.getFullYear();
    const month = d.getMonth();
    const daysCount = daysInMonth(year, month);

    const monthName = d.toLocaleString('en-US', { month: 'short' });

    let headers = [];
    for (let day = 1; day <= daysCount; day++) {
      headers.push({ head: `${monthName} ${day.toString().padStart(2, '0')}` });
    }

    return headers;
  };

  const tabelhead = yeardisplay ? generateTableHead(new Date(yeardisplay)) : [];

  const onGoClick = () => {
    setSelectedDate(new Date(month_fil_value));
  };

  const softRefresh = () => {
    setHasFetched(false);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    fetchData();
  }

  function isDateInFuture(dateStr) {
    // dateStr format: "DD-MM-YYYY"
    const [year, month, day] = dateStr.split('-').map(Number);
    // Create a Date object for the given date (months are 0-based)
    const givenDate = new Date(year, month - 1, day);

    // Create a Date object for today, set time to 00:00:00 to only compare dates
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return givenDate > today;
  }

  const bgstylefunc = (data) => {
    let bgStyle = {};
    if (data.payment_process === 1) {
      bgStyle = { background: "#FF857D" };
    } else if (data.status === 5) {
      bgStyle = { background: "#46BD4E" };
    } else if (data.status === 4) {
      bgStyle = { background: "#ecb0b0ff" };
    } else if (isDateInFuture(data.start_date)) {
      bgStyle = { background: "#7DB3FF" };
    }
    return bgStyle;
  }

  const daysCount = yeardisplay ? new Date(new Date(yeardisplay).getFullYear(), new Date(yeardisplay).getMonth() + 1, 0).getDate() : 30;

  // format date display
  const formatDate = (date) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const [isMaintenance, setIsMaintenance] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const checkMaintenanceStatus = async () => {
      try {
        const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
        const data = response.data.data || [];
        const branchStatus = data.find((item) => item.slug === "manage-subscriptions"); // use managebranch slug

        if (isMounted) {
          setIsMaintenance(branchStatus?.maintenancemode_status === 1);
        }
      } catch (error) {
        console.error("Error checking maintenance mode:", error);
        if (isMounted) setIsMaintenance(false);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    checkMaintenanceStatus();

    return () => {
      isMounted = false;
    };
  }, [baseURL, branch_id]);

  if (loading) {
    return <div>Loading...</div>; // optional loading state
  }

  if (isMaintenance) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center"
        style={{ height: "100vh", width: "100vw" }}
      >
        <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
        <p className="text-muted fs-5">
          The <strong>Manage Subscription</strong> module is currently under maintenance. <br />
          Please check back later.
        </p>
      </div>
    );
  }

  return (
    <>
      {/* headers */}
      <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0" style={{ marginBottom: 1 }}>
        <div className='mb-2'>
          <div className="mb-0 px-0">
            <h4 className='breadcrumb-header'>Manage Subscription</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Subscription Management</li>
          </ol>
        </div>

        <div className='row mb-2 '>
          <div className="d-flex align-items-center justify-content-center flex-wrap gap-3 my-2 flex-grow-1">
            <div className=' border border-gray800 py-2 d-flex align-items-center justify-content-start gap-2 flex-wrap rounded gap-2 px-2'>
              {[
                { color: '#46BD4E', label: 'Completed' },
                { color: '#FF857D', label: 'Payment Pending' },
                { color: '#7DB3FF', label: 'Upcoming' },
                { color: '#b0ecb8ff', label: 'Delivered' },
                { color: '#dde2ff', label: 'Hold' },
                { color: '#ecb0b0ff', label: 'Drop' },
                { color: '#d6d6d6ff', label: 'Holiday' }
              ].map((item, i) => (
                <div key={i} className="d-flex align-items-center gap-2">
                  <label
                    className="py-3 px-3 rounded"
                    style={{ backgroundColor: item.color }}
                  ></label>
                  <label className="fw-semibold text-black fs-6 mb-0">{item.label}</label>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* <div className='row mb-2 '>
          <div className=' border border-gray800 py-2 d-flex align-items-center justify-content-start gap-1 flex-wrap rounded gap-1'>
            <div className='d-flex align-items-center jsutify-content-start gap-2'>
              <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#46BD4E' }}>
                <span></span>
              </label>
              <label className='fw-semibold text-black fs-6'>Completed</label>
            </div>
            <div className='d-flex align-items-center jsutify-content-start gap-2'>
              <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#FF857D' }}>
                <span></span>
              </label>
              <label className='fw-semibold text-black fs-6'>Payment Pending</label>
            </div>
            <div className='d-flex align-items-center jsutify-content-start gap-2'>
              <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#7DB3FF' }}>
                <span></span>
              </label>
              <label className='fw-semibold text-black fs-6'>Upcoming</label>
            </div>
            <div className='d-flex align-items-center jsutify-content-start gap-2'>
              <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#b0ecb8ff' }}>
                <span></span>
              </label>
              <label className='fw-semibold text-black fs-6'>Delivered</label>
            </div>
            <div className='d-flex align-items-center jsutify-content-start gap-2'>
              <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#dde2ff' }}>
                <span></span>
              </label>
              <label className='fw-semibold text-black fs-6'>Hold</label>
            </div>
            <div className='d-flex align-items-center jsutify-content-start gap-2'>
              <label className="py-3 px-3 text-danger rounded" style={{ backgroundColor: '#ecb0b0ff' }}>
                <span></span>
              </label>
              <label className='fw-semibold text-black fs-6'>Drop</label>
            </div>

          </div>
        </div> */}

        {/* <div className="d-flex align-items-center justify-content-end mb-1">
          <div className="w-60 mb-1 col-lg-8">
            <div className='datepicker-wrapper d-flex'>
              <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
              <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)} maxDate={new Date()} onChange={(date) => setyeardisp(new Date(date))} />
              <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
            </div>
          </div>
        </div> */}

        {open && modalType === "EditSubscription" && (
          <EditSubscription show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
        )}
        {open && modalType === "ViewSubscription" && (
          <ViewSubscription show={open} onClose={() => setOpen(false)} selectedId={selectedId} />
        )}
        {open && modalType === "RenewalSubscription" && (
          <RenewalSubscription show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
        )}
        {open && modalType === "HoldSubscription" && (
          <HoldSubscription show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
        )}
        {open && modalType === "ComplaintsSubscription" && (
          <ComplaintsSubscription show={open} onClose={() => setOpen(false)} data={selectedRow} />
        )}
        {open && modalType === "SubSpecialCase" && (
          <SubSpecialCase show={open} onClose={() => setOpen(false)} data={selectedRow} id={selectedId} refresh={softRefresh} />
        )}
        {open && modalType === "SubscriptionPayment" && (
          <SubPayment show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
        )}
        {open && modalType === "DropStatus" && (
          <DropStatus show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
        )}

      </div>

      {/* <LoadingComponent loading={loading} /> */}

      {permissions.subscription_list === 1 && (
        <div className=' row'>

          {/* lable */}
          {/* <div className='col-lg-12'>
            <div className='text-red text-center font-w500 fs-2 mb-3 d-flex'>
              <label>Subscription </label>
              <label className='me-2 ms-2'>-</label>
              <label>{selectedDate ? new Date(selectedDate).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : 'Please select a month'}</label>
            </div>
          </div> */}

          {/* actions */}
          <div className='col-lg-12 mb-2'>

            <div className='row'>

              {/* month filter */}
              <div className="col-lg-3 mb-2">
                <label className="text-black font-w500 fs-7"></label>
                <div className='datepicker-wrapper d-flex'>
                  <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                  <DatePicker format="MMM-YYYY" value={yeardisplay} calendarPosition="top" mode="single" onlyMonthPicker={true} minDate={new Date(1900, 0, 1)} onChange={(date) => setyeardisp(new Date(date))} />
                  <div className='input-group-text bg-transparent border-0 px-0 py-0' style={{ padding: 0, margin: 0, display: 'flex', alignItems: 'center' }}><i class="fa-solid fa-caret-down fs-4"></i></div>
                </div>
              </div>

              {/* fetch button */}
              <div className="col-lg-7 mt-4 d-flex align-items-center justify-content-start gap-1">
                {/* <Button className="me-2 btn-sm" variant="secondary" onClick={onGoClick}>
                  <span className='font-w400'>Go</span>
                </Button> */}

              </div>

              {/* filter button */}
              <div className='col-lg-2 mt-4 d-flex align-items-end justify-content-end'>
                <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                  <span className='me-2'><i class="fa-solid fa-filter fs-8"></i></span>
                  <span className=''>Filter</span>
                </Link>
              </div>
            </div>

          </div>

          {/* table */}
          {hasFetched && (
            <div className='col-md-12 '>
              <div style={{ position: "relative" }}>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* Left: Show entries dropdown */}
                  <div>
                    <label className="me-2">Show</label>
                    <select
                      className="form-select d-inline w-auto"
                      style={{ fontSize: '0.85rem', height: '30px' }}
                      value={perPage}
                      onChange={(e) => {
                        setPerPage(Number(e.target.value));
                        setPage(1); // Reset to first page
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>

                  {/* Right: Search input */}
                  <div>
                    <input
                      type="text"
                      style={{ fontSize: '0.85rem', height: '40px' }}
                      placeholder="Search..."
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setPage(1); // Reset page on new search
                      }}
                    />
                  </div>
                </div>

                <div ref={tableScrollRef} style={{ overflowX: "auto", overflowY: "auto", maxHeight: "600px", maxWidth: "100%", border: "1px solid #dee2e6", }}>

                  <table ref={tableRef} className="table table-bordered text-center align-middle mb-0">
                    <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                      <tr>
                        {/* <th style={{ ...thStyle, ...stickyLeft1 }} className=" text-white fw-bold fs-6 gs-0 th_head text-start">Subscriber</th> */}
                        {/* <th style={{ ...thStyle, ...stickyLeft2 }} className=" text-white fw-bold fs-6 gs-0 th_head text-start">Customer</th> */}
                        <th style={{ ...thStyle, ...stickyLeft1 }} className=" text-white fw-bold fs-6 gs-0 th_head text-start">Subscription</th>

                        {tabelhead.map((item) => (
                          <th style={thStyle} className=" text-white fw-bold fs-6 gs-0 th_head">{item.head}</th>
                        ))}

                      </tr>
                    </thead>
                    <tbody>
                      {datas.length === 0 && hasFetched && (
                        <tr>
                          <td colSpan="3" className="text-center text-muted py-2">
                            No data available
                          </td>
                          <td colSpan={tabelhead.length} className="text-center text-muted py-2">
                            -
                          </td>
                        </tr>
                      )}
                      {datas.map((data, index) => (
                        <tr key={data.sno}>
                          {/* <td style={{ ...tdStyleFirstTwo, ...stickyLeft1, ...bgstylefunc(data) }}>
                            <div className='d-flex flex-column align-items-start mt-3'>
                              <div className='d-flex flex-column align-items-start'>
                                <label className="text-black font-w600 fs-7 text-wrap text-start text-wrap text-start">{data.lead_name} ({data.lead_mobile_no})</label>
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Subscription End Date</span></Tooltip>} >
                                  <label className='text-danger border border-danger rounded py-1 px-1 fw-bold fs-7'>{formatDate(data.end_date)}</label>
                                </OverlayTrigger>
                                {data.is_user_display === 1 && (
                                  <>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Customer Details</span></Tooltip>} >
                                      <label className="text-black font-w500 fs-7 d-block">{data.delivery_person_name} {data.delivery_contact_number}</label>
                                    </OverlayTrigger>
                                  </>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={{ ...tdStyleFirstTwo, ...stickyLeft2, ...bgstylefunc(data) }}>
                            <div className='d-flex flex-column align-items-start mt-3'>
                              <div className='d-flex flex-column align-items-start'>
                                <label className="text-black font-w600 fs-7 text-wrap text-start">{data.delivery_person_name}</label>
                                <label className="text-black font-w500 fs-7 d-block">{data.delivery_contact_number}</label>
                              </div>
                            </div>
                          </td> */}

                          <td style={{ ...tdStyleFirstTwo, ...stickyLeft1, ...bgstylefunc(data) }}>
                            <div className='d-flex flex-column'>
                              {/* details */}
                              <div className='d-flex flex-column'>
                                <label className="text-black font-w600 fs-7 text-wrap text-start text-wrap text-start">{data.lead_name} ({data.lead_mobile_no})</label>
                                <label className="text-black font-w600 fs-7 text-wrap text-start text-wrap">{data.package_name}</label>
                                {/* <label className="text-black font-w500 fs-7 text-wrap text-start text-wrap">(<span className='text-danger mx-1'>{data.timeline_name} {data.timeline_days} Days</span>)</label> */}
                                {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Subscription Start Date</span></Tooltip>} >
                                  <label className='text-primary text-start py-1 px-1 fw-bold fs-7'>{formatDate(data.start_date)}</label>
                                </OverlayTrigger> */}
                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Subscription End Date</span></Tooltip>} >
                                  <label className='text-danger text-start py-1 px-1 fw-bold fs-7'>{formatDate(data.end_date)}</label>
                                </OverlayTrigger>
                              </div>

                              {/* actions */}
                              <div className='d-flex flex-column'>
                                <div className='d-flex justify-content-left align-items-left'>

                                  {/* renewal */}
                                  {data.status === 5 && permissions.subscription_renewal === 1 && (
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Renew</span></Tooltip>} >
                                      <Link to={`/manage-subscriptions-renew?data=${data.sno}`}>
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1">
                                          <span><i class="fa-solid fa-retweet fs-6 mt-1"></i></span>
                                        </Button>
                                      </Link>
                                    </OverlayTrigger>
                                  )}

                                  {/* payment */}
                                  {data.payment_process === 1 && permissions.subscription_payment === 1 && (
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Payment</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => SubscriptionPaymentModel(data)}>
                                        <style>
                                          {`@keyframes blink {
                                          0%, 50%, 100% { opacity: 1; }
                                          25%, 75% { opacity: 0; }
                                        }`}
                                        </style>
                                        <span style={blinkingStyle}><i class="fa-solid fa-indian-rupee-sign fs-5 mt-1 text-danger"></i></span>
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {/* hold */}
                                  {data.status !== 4 && data.status !== 5 && permissions.subscription_hold === 1 && (
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Hold</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => HoldSubscriptionModal(data)}>
                                        <span><i class="fa-solid fa-circle-pause fs-5 mt-1"></i></span>
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {/* drop */}
                                  {data.status !== 4 && data.status !== 5 && permissions.subscription_drop === 1 && (
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Drop</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => ConstDropStatus(data)}>
                                        <span><i class="fa-solid fa-circle-xmark fs-5 mt-1"></i></span>
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {/* view */}
                                  {permissions.subscription_view === 1 && (
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => ViewSubscriptionModal(data.sno)}>
                                        <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                  {/* edit */}
                                  {data.status !== 4 && data.status !== 5 && permissions.subscription_edit === 1 && (
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => EditSubscriptionModal(data)}>
                                        <span><i class="fa-solid fa-pen-to-square fs-5 mt-1"></i></span>
                                      </Button>
                                    </OverlayTrigger>
                                  )}

                                </div>
                              </div>
                            </div>
                          </td>

                          {/* {Array.from({ length: daysCount }, (_, i) => {
                            const day = i + 1;
                            const status = data.dayStatus[day];
                            // console.log(status);
                            return (
                              <td key={day}
                                style={{
                                  minWidth: "100px",
                                  height: "100px",
                                  border: "1px solid #dee2e6",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  background: status ? status.bgcolor : "transparent",
                                }}
                              >
                                <div className="mt-3">
                                  <label className="fs-3 font-w500 text-black">{status ? status.label : ''}</label>
                                </div>
                              </td>
                            );
                          })} */}

                          {Array.from({ length: daysCount }, (_, i) => {
                            const day = i + 1;
                            const status = data.dayStatus[day];

                            // if(index == 1){
                            //   console.log("day: ", day, " sts: ", status);
                            // }

                            if (status === 0) {
                              return (
                                <td key={day} style={{ minWidth: "100px", height: "100px", border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle", background: "transparent" }} className='align-content-center'>
                                  <div className="mt-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>No Delivery</span></Tooltip>} >
                                      <span><i class="fa-solid fa-minus fs-6 mt-1 text-black"></i></span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              );
                            } else if (status === 1) {
                              return (
                                <td key={day} style={{ minWidth: "100px", height: "100px", border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle", background: "#b0ecb8ff" }} className='align-content-center'>
                                  <div className="mt-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivered</span></Tooltip>} >
                                      <span><i class="fa-solid fa-check fs-6 mt-1 text-primary"></i></span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              );
                            } else if (status === 2) {
                              return (
                                <td key={day} style={{ minWidth: "100px", height: "100px", border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle", background: "#ecb0b0ff" }} className='align-content-center'>
                                  <div className="mt-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Returned</span></Tooltip>} >
                                      <span><i class="fa-solid fa-xmark fs-6 mt-1 text-danger"></i></span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              );
                            } else if (status === 3) {
                              return (
                                <td key={day} style={{ minWidth: "100px", height: "100px", border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle", background: "#d6d6d6ff" }} className='align-content-center'>
                                  <div className="mt-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Holiday</span></Tooltip>} >
                                      <span><i class="fa-solid fa-h fs-6 mt-1 text-info"></i></span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              );
                            } else if (status === 4) {
                              return (
                                <td key={day} style={{ minWidth: "100px", height: "100px", border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle", background: "#dde2ff" }} className='align-content-center'>
                                  <div className="mt-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Hold</span></Tooltip>} >
                                      <span><i class="fa-solid fa-pause fs-6 mt-1 text-warning"></i></span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              );
                            } else if (status === 5) {
                              return (
                                <td key={day} style={{ minWidth: "100px", height: "100px", border: "1px solid #dee2e6", textAlign: "center", verticalAlign: "middle", background: "#7DB3FF" }} className='align-content-center'>
                                  <div className="mt-3">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Future</span></Tooltip>} >
                                      <span><i class="fa-solid fa-minus fs-6 mt-1 text-black"></i></span>
                                    </OverlayTrigger>
                                  </div>
                                </td>
                              );
                            }
                          })}

                        </tr>
                      ))}

                    </tbody>
                  </table>

                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  {/* Bottom left: Showing x to y of z entries */}
                  <div>
                    {datas.length > 0 ? (
                      <span className="text-muted">
                        Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                      </span>
                    ) : (
                      <span className="text-muted">
                        Showing 0 to 0 of 0 entries
                      </span>
                    )}
                  </div>

                  {/* Bottom right: Pagination */}

                  <nav>
                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                      {/* Previous Button */}
                      <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                          Previous
                        </button>
                      </li>

                      {/* First Page */}
                      <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                          1
                        </button>
                      </li>

                      {/* Left Ellipsis */}
                      {page > 4 && (
                        <li className="page-item disabled">
                          <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                        </li>
                      )}

                      {/* Pages Around Current */}
                      {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                        .map(p => (
                          <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                              {p}
                            </button>
                          </li>
                        ))}

                      {/* Right Ellipsis */}
                      {page < totalPages - 3 && (
                        <li className="page-item disabled">
                          <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                        </li>
                      )}

                      {/* Last Page */}
                      {totalPages > 1 && (
                        <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                          <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                            {totalPages}
                          </button>
                        </li>
                      )}

                      {/* Next Button */}
                      <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>

                </div>
              </div>
            </div>
          )}

        </div>
      )}

      {/* filter */}
      <Drawer
        anchor="right"
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        disableEscapeKeyDown
        BackdropProps={{
          onClick: (e) => e.stopPropagation(),
        }}
        sx={{
          width: 400,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 400,
            boxSizing: 'border-box',
          },
          '@media (max-width: 375px)': {
            '& .MuiDrawer-paper': {
              width: 320,
            },
          },
          '@media (max-width: 320px)': {
            '& .MuiDrawer-paper': {
              width: 280,
            },
          },
        }}
      >
        <div className='modal-header mb-0 px-4 pt-2 pb-0'>
          <h5 className='fs-4' style={{ color: '#ea1d25' }}>Subscribers Filter</h5>
          <div>
            <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
              <span className='fs-2'>×</span>
            </Button>
          </div>
        </div>
        <div className='card border-0'>
          <div className='card-body py-0'>
            <div className='row mb-2 py-2'>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Package Name</label>
                <Select
                  value={packageOption.find(option => option.value === pack) || null}
                  onChange={(selectedOption) => setPack(selectedOption.value)}
                  options={packageOption}
                  placeholder="Select Package"
                />
              </div>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Schedule</label>
                <Select
                  value={scheduleOption.find(option => option.value === schedule) || null}
                  onChange={(selectedOption) => setschedule(selectedOption.value)}
                  options={scheduleOption}
                  placeholder="Select Package"
                />
              </div>

              {/* <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Subscribers</label>
                <Select
                  value={subsribersOpt.find(option => option.value === filter_subs_id) || null}
                  onChange={(selectedOption) => setFilterSubsID(selectedOption.value)}
                  options={subsribersOpt}
                  placeholder="Select Subscribers"
                />
              </div>

              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Mobile No</label>
                <input type="text" className="form-control" placeholder="Enter Mobile No"
                  value={filtermob_no}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                    setFilterMob(onlyNums);
                  }}
                />
              </div> */}


              <div className="col-lg-12 mb-2">
                <label className="text-black font-w500 fs-7">Date</label>
                <Select
                  value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                  onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                  options={date_fil_options}
                  menuPlacement="top"
                />
              </div>
              {date_fil_selt_value === "all" && <></>}
              {date_fil_selt_value === "today" && (
                <div className="col-lg-12 mb-2">
                  <label className="text-black font-w500 fs-7">Today</label>
                  <div className='datepicker-wrapper d-flex'>
                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                    <DatePicker
                      // value={"05/18/2020 02:20:36 PM"}
                      value={today_fil_value}
                      onChange={setTodayFilValue}
                      format="DD-MM-YYYY"
                      // format="DD/MM/YYYY hh:mm:ss A"
                      readOnly={true}
                    />
                  </div>
                </div>
              )}
              {date_fil_selt_value === "this_week" && (
                <>
                  <div className="col-lg-6 mb-2">
                    <label className="text-black font-w500 fs-7">Start Date</label>
                    <div className='datepicker-wrapper d-flex'>
                      <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                      <DatePicker
                        value={week_stdt_fil_value}
                        onChange={setWeekSTDTFilValue}
                        format="DD-MM-YYYY"
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="text-black font-w500 fs-7">End Date</label>
                    <div className='datepicker-wrapper d-flex'>
                      <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                      <DatePicker
                        value={week_eddt_fil_value}
                        onChange={setWeekEDDTFilValue}
                        format="DD-MM-YYYY"
                        calendarPosition="top-end"
                        readOnly={true}
                      />
                    </div>
                  </div>
                </>
              )}
              {date_fil_selt_value === "this_month" && (
                <div className="col-lg-12 mb-2">
                  <label className="text-black font-w500 fs-7">This Month</label>
                  <div className='datepicker-wrapper d-flex'>
                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                    <DatePicker
                      value={month_fil_value_filter}
                      onChange={setMonthFilValueFilter}
                      format="MMM-YYYY"
                      calendarPosition="top"
                      mode="single"
                      onlyMonthPicker={true}
                      readOnly={true}
                    />
                  </div>
                </div>
              )}
              {date_fil_selt_value === "custom" && (
                <>
                  <div className="col-lg-6 mb-2">
                    <label className="text-black font-w500 fs-7">Start Date</label>
                    <div className='datepicker-wrapper d-flex'>
                      <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                      <DatePicker
                        value={custom_stdt_fil_value}
                        onChange={setCustomSTDTFilValue}
                        format="DD-MM-YYYY"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 mb-2">
                    <label className="text-black font-w500 fs-7">End Date</label>
                    <div className='datepicker-wrapper d-flex'>
                      <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                      <DatePicker
                        value={custom_eddt_fil_value}
                        onChange={setCustomEDDTFilValue}
                        format="DD-MM-YYYY"
                        calendarPosition="top-end"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-1">
            <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
              setFilterSubsID(null);
              setFilterMob('');
              setPack(null);
              setschedule(null);
              setDateFilSeltValue('all');
              softRefresh();
              onClose();
            }}>
              <span className='font-w400'>Reset</span>
            </Button>
            <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
              <span className='font-w400'>Go</span>
            </Button>
          </div>
        </div>
      </Drawer>


      {permissions.subscription_list === 0 && (
        <div className='align-content-center' style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '10%',
          // height: '100vh',       // full viewport height
          color: 'red',          // text-danger equivalent
          fontSize: '24px',      // increase font size
          fontWeight: 'bold'     // optional for emphasis
        }}>
          <label>No Access</label>
        </div>
      )}

    </>

  );
};

export default Subscription;